import classcat from "classcat";
import React, { useCallback } from "react";

import { IconLeft } from "@touchtech/web-baselayer-ui";

import { DELETE } from "../Passcode.constants";
import css from "./PasscodeItem.module.css";

type Props = {
  value: string;
  onClick: (value: string) => void;
};

const PasscodeItem = ({ value, onClick }: Props) => {
  const handleClick = useCallback(() => {
    onClick(value);
  }, [onClick, value]);

  return (
    <button
      onClick={handleClick}
      className={classcat([
        css.container,
        "text-label-2xl",
        { [css.invisible]: !value },
      ])}
    >
      {value === DELETE ? <IconLeft /> : value}
    </button>
  );
};

export default PasscodeItem;
